module.exports = __webpack_public_path__ + "static/media/0286_Small.bd7d30d8.jpg";